module.exports = __webpack_public_path__ + "img/icon-unverified.24ce5619.svg";